import { useTrackWithUser } from '@ion/api';

import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const STATIC_CLUSTER_SELECT_PROPS = {
  size: 'small',
  variant: 'outlined',
};

export default function useEventDebuggerClusterSelectProps() {
  const [trackClusterSelected] = useTrackWithUser('event_debugger_cluster_selected');
  const { cluster, onClusterChange } = useEventDebuggerTableContext();

  const clusterSelectProps = {
    ...STATIC_CLUSTER_SELECT_PROPS,
    defaultValue: cluster,
    onChange: onClusterChange,
    onOpen: trackClusterSelected,
  };

  return clusterSelectProps;
}
